import { zodResolver } from "@hookform/resolvers/zod";
import { FormProvider, useForm } from "react-hook-form";

import { uploadFilesSchema } from "@/shared/models/legacy-schemas";
import type { DocumentFolder } from "@/shared/models/legacy-types";
import { DocumentUploadsSubmit } from "./document-uploads-submit";
import { FileUploads } from "./file-uploads";

interface DocumentUploadsProps {
  folder: DocumentFolder;

  onCancel: () => void;
  onSuccess: () => void;
}

export const DocumentUploads = (props: DocumentUploadsProps) => {
  const { onCancel, onSuccess, folder } = props;

  const methods = useForm({
    resolver: zodResolver(uploadFilesSchema),
    defaultValues: { type: folder, files: [] },
  });

  return (
    <FormProvider {...methods}>
      <form className="flex grow flex-col gap-5">
        <FileUploads />

        <DocumentUploadsSubmit onCancel={onCancel} onSuccess={onSuccess} />
      </form>
    </FormProvider>
  );
};
